 document.addEventListener("DOMContentLoaded", function(event) {
let product_grid = document.querySelectorAll('.grid__item');
product_grid.forEach(function(item) {
  item.addEventListener("click", function () {
    let body = document.querySelector('body');
    let page_name = body ? body.getAttribute('data-template') : null;
    console.log(page_name);
    sessionStorage.setItem("page_name", page_name);
  });
});

if(window.location.href.indexOf('/product') > -1){
  let page_name =  sessionStorage.getItem("page_name");
    if(page_name == 'index'){
        
    }else{
      if(document.querySelector('.home_link')){
        document.querySelector('.home_link').style.display = 'none';  
      }
     
    }
} 

async function addToCart(variantId, quantity = 1) {
  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: [
          {
            id: variantId,
            quantity: quantity
          }
        ]
      })
    });

    const data = await response.json();

    console.log('Added to cart:', data);
    if (document.querySelector('#recommendation-container')) {
         updateRecommendationsFromCart(); 
        }
    document.querySelector('#recommendation-container').style.display = 'block';
     document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: {
            product: data,
            
          },
          bubbles: true
        }));
  
        if (this.args && this.args.scopedEventId) {
          document.dispatchEvent(new CustomEvent('ajaxProduct:added:' + this.args.scopedEventId, {
            detail: {
              product: data,
            }
          }));
        }
  } catch(error) {
    console.error('Cart Error:', error);
  }
}
document.addEventListener('click', function(e) {
  const button = e.target.closest('.quick_add_btn');
  if (!button) return;
  e.preventDefault();
  const variantId = button.dataset.id;
  addToCart(variantId);
});


document.querySelectorAll(".whatsapp-audio-player").forEach((player) => {

  const audio = player.querySelector(".custom-audio");

  const playButton = player.querySelector(".whatsapp-audio-player__play");

  const icon = playButton.querySelector("i");

  const waves = player.querySelectorAll(".wave");

  const currentTime = player.querySelector(".audio-time");

  playButton.addEventListener("click", () => {

    if (audio.paused) {

      audio.play();

      icon.classList.remove("fa-play");

      icon.classList.add("fa-pause");

    } else {

      audio.pause();

      icon.classList.remove("fa-pause");

      icon.classList.add("fa-play");

    }

  });

  audio.addEventListener("loadedmetadata", () => {

    const minutes = Math.floor(audio.duration / 60);

    const seconds = Math.floor(audio.duration % 60)
      .toString()
      .padStart(2, "0");

    currentTime.textContent = `${minutes}:${seconds}`;

  });

  audio.addEventListener("timeupdate", () => {

    const progress = audio.currentTime / audio.duration;

    const activeWaves = Math.floor(progress * waves.length);

    waves.forEach((wave, index) => {

      if (index <= activeWaves) {

        wave.classList.add("active");

      } else {

        wave.classList.remove("active");

      }

    });

    const minutes = Math.floor(audio.currentTime / 60);

    const seconds = Math.floor(audio.currentTime % 60)
      .toString()
      .padStart(2, "0");

    currentTime.textContent = `${minutes}:${seconds}`;

  });

  audio.addEventListener("ended", () => {

    icon.classList.remove("fa-pause");

    icon.classList.add("fa-play");

  });

});
document.querySelectorAll(".whatsapp-audio-player").forEach((player) => {

  const audio = player.querySelector(".custom-audio");

  const speedButton = player.querySelector(".whatsapp-audio-player__speed");

  const speeds = [1, 1.5, 2];

  let currentSpeedIndex = 0;

  speedButton.addEventListener("click", () => {

    currentSpeedIndex++;

    if (currentSpeedIndex >= speeds.length) {
      currentSpeedIndex = 0;
    }

    const speed = speeds[currentSpeedIndex];

    audio.playbackRate = speed;

    speedButton.textContent = `${speed}×`;

  });

});
 });